import config from '../../config'
import ApiRequest from '../request'
import axios from 'axios'

export default class Copros {
  constructor() {
    this.apiRequest = new ApiRequest()
  }
  async getByMondayId(id) {
    try {
      const res = await this.apiRequest.get(`copros_monday/${id}`)
      return res
    } catch (error) {
      return error.response
    }
  }
  async getGeneralNews(params) {
    try {
      const res = await this.apiRequest.get('ext_copros_general_news', params)
      return res
    } catch (error) {
      return error.response
    }
  }

  async getEventsFromCopro(copro_id, start, end) {
    copro_id = Number(copro_id)
    try {
      const res = await this.apiRequest.get(`/copros/${copro_id}/events`, {
        start,
        end,
      })
      return res
    } catch (error) {
      console.log('error', error)
    }
  }
  async getFicheImmeubleFromCopro(copro_id) {
    try {
      const res = await this.apiRequest.get(`/copros/${copro_id}/copro_fiche`)
      return res
    } catch (error) {
      console.log('error', error)
    }
  }
  async getFiles(coproprietaire_id, params) {
    try {
      const res = await this.apiRequest.get(
        `/ext_file_with_context/coowner/${coproprietaire_id}`,
        params
      )
      return res
    } catch (error) {
      console.log('error', error)
    }
  }
  async getChoicesDocs(coproprietaire_id, params = {}) {
    try {
      const res = await this.apiRequest.get(
        `/ext_file_with_context/coowner/choices/${coproprietaire_id}`,
        params
      )
      return res
    } catch (error) {
      console.log('error', error)
    }
  }
  async getAccountingTicket(copro_monday_internal_id, params = {}) {
    try {
      const res = await this.apiRequest.get(
        `ext_accounting_tickets/${copro_monday_internal_id}`,
        params
      )
      return res
    } catch (error) {
      return error.response
    }
  }
  async getCoproChoicesDocs(copro_id, params = {}) {
    try {
      const res = await this.apiRequest.get(
        `/copros/${copro_id}/docs/choices`,
        params
      )
      return res
    } catch (error) {
      console.log('error', error)
    }
  }
  async getDetailsCopro(copro_id) {
    try {
      const res = await this.apiRequest.get(`/copros/${copro_id}`)
      return res
    } catch (error) {
      console.log('error', error)
    }
  }
  async attachCopro(payload) {
    try {
      const res = await this.apiRequest.post(`users_copros`, { ...payload })
      return res
    } catch (error) {
      return error.response
    }
  }
  async getCoproprietairesByCopro(copro_id, params = {}) {
    try {
      const res = await this.apiRequest.get(
        `v2/internal/copros/${copro_id}/coowners`,
        params
      )
      return res
    } catch (error) {
      return error.response
    }
  }

  async getContactsFromCopro(copro_id) {
    try {
      return await axios({
        method: 'get',
        url: `${config.BASE_URL_V2}/backoffice/condominiums/${copro_id}/contacts`,
        headers: {
          auth_token: config.auth_token,
        },
      })
    } catch (error) {
      return error
    }
  }

  async getCopros() {
    try {
      return await this.apiRequest.get('copros')
    } catch (error) {
      return error.response
    }
  }

  async getByIban(iban) {
    return await this.apiRequest.get(
      `${config.BASE_URL_V2}/backoffice/condominiums/search-by-iban/${iban}`
    )
  }
}
